import { useState } from 'react';
import { useNavigate } from 'react-router';
import { ChevronsUpDown, KeyRound, LogOut } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { roleLabel } from '@/lib/roles';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { UserAvatar } from '@/components/domain/avatars';
import { ChangePasswordDialog } from '@/routes/auth/change-password-dialog';

export function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [passwordOpen, setPasswordOpen] = useState(false);

  if (!user) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="gap-2 px-1.5" aria-label={`Cuenta de ${user.fullName}`}>
            <UserAvatar user={user} size="xs" />
            <span className="hidden max-w-[140px] truncate sm:inline">{user.fullName}</span>
            <ChevronsUpDown className="hidden text-fg-subtle sm:inline" aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end" className="w-64">
          <DropdownMenuLabel>Sesión</DropdownMenuLabel>
          <div className="flex items-center gap-3 px-2 pb-2">
            <UserAvatar user={user} size="md" />
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-fg">{user.fullName}</p>
              <p className="truncate text-xs text-fg-muted">{user.email ?? user.code}</p>
              <p className="mt-0.5 text-2xs text-fg-subtle">
                {user.jobTitle ?? roleLabel(user.role)}
              </p>
            </div>
          </div>

          <DropdownMenuSeparator />

          <DropdownMenuItem onSelect={() => setPasswordOpen(true)}>
            <KeyRound aria-hidden="true" />
            Cambiar contraseña
          </DropdownMenuItem>

          <DropdownMenuSeparator />

          <DropdownMenuItem
            destructive
            onSelect={() => {
              void logout().then(() => navigate('/login', { replace: true }));
            }}
          >
            <LogOut aria-hidden="true" />
            Cerrar sesión
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ChangePasswordDialog open={passwordOpen} onOpenChange={setPasswordOpen} />
    </>
  );
}
